import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Products from './pages/Products';
import Contact from './pages/Contact';
import AboutUs from './pages/AboutUs';
import Technologies from './pages/Technologies';
import Services from './pages/Services';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Container from '@mui/material/Container';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import LegalCompliance from './pages/LegalCompliance';
function App() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navbar />
      <Container component="main" sx={{ flexGrow: 1, py: 4 }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/technologies" element={<Technologies />} />          
          <Route path="/services" element={<Services />} />
          <Route path="/contact-us" element={<Contact />} />      
          <Route path="/about-us" element={<AboutUs />} />     
          <Route path="/privacy-policy" element={<PrivacyPolicy />} /> 
          <Route path="/privacy-policy" element={<PrivacyPolicy />} /> 
          <Route path="/terms-of-service" element={<TermsOfService />} /> 
          <Route path="/legal-compliance" element={<LegalCompliance />} />
        </Routes>
      </Container>
      <Footer />
    </div>
  );
}

export default App;